export function resize(height: number) {
  window.parent.postMessage({ action: 'resetWindow', height }, '*');
}

export function scrollCategoryAccordion(params: { top?: number; containerHeight?: number }) {
  const action = 'scrollToCategoryName';
  if (params.top !== undefined) {
    window.parent.postMessage({ action, top: params.top }, '*');
  } else if (params.containerHeight !== undefined) {
    window.parent.postMessage({ action, containerHeight: params.containerHeight }, '*');
  }
}
